<ion-list>
  <ion-item
    (click)="downloadAll('mp4')"
    [disabled]="zipObject.mp4?.isZippingFiles || !mp4Downloads.length"
    button="true"
    lines="none">
    <div class="spinner-container" *ngIf="zipObject.mp4?.isZippingFiles === true">
      <mat-progress-spinner
        mode="determinate"
        [value]="zipObject.mp4.zipProgress"
        [tooltip]="zipObject.mp4?.zipProgress + '% Zipped'"
        diameter="30"
        strokeWidth="2"
        class="audio"></mat-progress-spinner>
      <ion-icon
        *ngIf="zipObject.mp4?.isZippingFiles === true"
        src="/assets/icons/24px/download-multiple.svg"
        slot="start"
        class="progress"></ion-icon>
    </div>
    <ion-label *ngIf="zipObject.mp4?.isZippingFiles === true">
      Zipping Files...
      <p>{{ zipObject.mp4?.zipProgress }}%</p>
    </ion-label>

    <ion-icon
      *ngIf="zipObject.mp4?.isZippingFiles === false"
      src="/assets/icons/24px/download-multiple.svg"
      slot="start">
    </ion-icon>

    <ion-label *ngIf="zipObject.mp4?.isZippingFiles === false">
      Download <span *ngIf="all">All </span>MP4

      <p>Audio + Video</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="downloadAll('webm')"
    *ngIf="webmDownloads.length"
    [disabled]="zipObject.webm?.isZippingFiles"
    button="true"
    lines="none">
    <div class="spinner-container" *ngIf="zipObject.webm?.isZippingFiles === true">
      <mat-progress-spinner
        mode="determinate"
        [value]="zipObject.webm.zipProgress"
        [tooltip]="zipObject.webm?.zipProgress + '% Zipped'"
        diameter="30"
        strokeWidth="2"
        class="audio"></mat-progress-spinner>
      <ion-icon
        *ngIf="zipObject.webm?.isZippingFiles === true"
        src="/assets/icons/24px/download-multiple.svg"
        slot="start"
        class="progress"></ion-icon>
    </div>
    <ion-label *ngIf="zipObject.webm?.isZippingFiles === true">
      Zipping Files...
      <p>{{ zipObject.webm?.zipProgress }}%</p>
    </ion-label>

    <ion-icon
      *ngIf="zipObject.webm?.isZippingFiles === false"
      src="/assets/icons/24px/download-multiple.svg"
      slot="start">
    </ion-icon>
    <ion-label *ngIf="zipObject.webm?.isZippingFiles === false">
      Download <span *ngIf="all">All </span>Webm

      <p>Video Only</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="downloadAll('wav')"
    [disabled]="zipObject.wav?.isZippingFiles || !wavDownloads.length"
    button="true"
    lines="none">
    <div class="spinner-container" *ngIf="zipObject.wav?.isZippingFiles === true">
      <mat-progress-spinner
        mode="determinate"
        [value]="zipObject.wav.zipProgress"
        [tooltip]="zipObject.wav?.zipProgress + '% Zipped'"
        diameter="30"
        strokeWidth="2"
        class="audio"></mat-progress-spinner>
      <ion-icon
        *ngIf="zipObject.wav?.isZippingFiles === true"
        src="/assets/icons/24px/download-multiple.svg"
        slot="start"
        class="progress"></ion-icon>
    </div>

    <ion-label *ngIf="zipObject.wav?.isZippingFiles === true">
      Zipping Files...
      <p>{{ zipObject.wav?.zipProgress }}%</p>
    </ion-label>

    <ion-icon
      *ngIf="zipObject.wav?.isZippingFiles === false"
      src="/assets/icons/24px/download-multiple.svg"
      slot="start">
    </ion-icon>

    <ion-label *ngIf="zipObject.wav?.isZippingFiles === false">
      Download <span *ngIf="all">All </span>Wav

      <p>Audio Only</p>
    </ion-label>
  </ion-item>

  <ion-item
    (click)="downloadAll('mp3')"
    [disabled]="zipObject.mp3?.isZippingFiles || !mp3Downloads.length"
    button="true"
    lines="none">
    <div class="spinner-container" *ngIf="zipObject.mp3?.isZippingFiles === true">
      <mat-progress-spinner
        mode="determinate"
        [value]="zipObject.mp3.zipProgress"
        [tooltip]="zipObject.mp3?.zipProgress + '% Zipped'"
        diameter="30"
        strokeWidth="2"
        class="audio"></mat-progress-spinner>
      <ion-icon
        *ngIf="zipObject.mp3?.isZippingFiles === true"
        src="/assets/icons/24px/download-multiple.svg"
        slot="start"
        class="progress"></ion-icon>
    </div>

    <ion-label *ngIf="zipObject.mp3?.isZippingFiles === true">
      Zipping Files...
      <p>{{ zipObject.mp3?.zipProgress }}%</p>
    </ion-label>

    <ion-icon
      src="/assets/icons/24px/download-multiple.svg"
      slot="start"
      *ngIf="zipObject.mp3?.isZippingFiles === false">
    </ion-icon>

    <ion-label *ngIf="zipObject.mp3?.isZippingFiles === false">
      Download <span *ngIf="all">All </span>MP3

      <p>Audio Only</p>
    </ion-label>
  </ion-item>
  <ion-item lines="none" *ngIf="all">
    <ion-label class="zip-info-button-container">
      <p>Zip Downloads</p>
      <ion-button
        tooltip="Zip up all your downloads. Disable for individual downloads"
        aria-label="Zip up all your downloads"
        class="text ion-no-padding">
        <ion-icon src="assets/icons/16px/info-outline.svg"></ion-icon>
      </ion-button>
    </ion-label>
    <ion-toggle [(ngModel)]="enableZip" color="secondary" mode="ios" slot="end"> </ion-toggle>
  </ion-item>
</ion-list>

<div id="downloadAllContainer">
  <div *ngFor="let mp4Download of mp4Downloads">
    <a *ngIf="mp4Download.mp4" [href]="mp4Download.mp4" download class="mp4Download"> </a>
  </div>

  <div *ngFor="let webmDownload of webmDownloads">
    <a *ngIf="webmDownload.webm" [href]="webmDownload.webm" download class="webmDownload"> </a>
  </div>

  <div *ngFor="let wavDownload of wavDownloads">
    <a *ngIf="wavDownload.wav" [href]="wavDownload.wav" download class="wavDownload"> </a>
  </div>

  <div *ngFor="let mp3Download of mp3Downloads">
    <a *ngIf="mp3Download.mp3" [href]="mp3Download.mp3" download class="mp3Download"> </a>
  </div>
</div>
